/* this file is transformed by vux-loader */
/* eslint-disable */
/*
 * 缓存在localstorage的键值
 * 数据结构：namespace/key （模块命名空间 + 具体state键值）
 */
export default ['globalStore/user', 'appStore/sessionID', 'appStore/isReadPrivacy'];